module.exports = __webpack_public_path__ + "static/marche-1e2a4bc2c1f2bd73ff8141b823a3260d.woff";